// Shared in multiple components
export const SAVESTATES = {
  FAILED: "Failed to save",
  SAVING: "Saving...",
  SAVED: "Saved",
  NONE: ""
};

export const REFERRAL_STATES = {
  WITHDRAWN: "withdrawn",
  APPROVED: "approved",
  DECLINED: "declined"
};

export const PREMIUM = {
  PREMIUM_UNAVAILABLE: "Pricing unavailable",
  PREMIUM_NEEDED_QUOTE_COPY: "Premium needed to get quote link.",
  PREMIUM_NEEDED_DOCS_COPY: "Premium needed to view documents.",
  PREMIUM_BREAKDOWN_UNAVAILABLE:
    "Premium unavailable. Fill out all required questions to get a premium."
};

export const QUOTE_TYPE = {
  QUOTE: "Quote",
  POLICY: "Policy"
};

export enum FilterCreatedBy {
  ALL = 0,
  USER = 1,
  REMARKETING = 2,
  XMLEAD = 3
}

export const QuoteFilters = [
  {
    label: "All quotes",
    name: "allQuotes",
    filterType: "reset",
    sortField: "updateTimestamp",
    sortDir: "desc",
    featureFlag: "quote-discovery-filters-v2"
  },
  {
    label: "Only my quotes",
    name: "createdByUser",
    filterType: "base",
    property: "showAll",
    activeValue: false,
    sortField: "updateTimestamp",
    sortDir: "desc"
  },
  {
    label: "Remarketing",
    name: "remarketing",
    slug: "remarketing",
    filterType: "and",
    property: "quotegroup",
    activeValue: "remarketing",
    sortField: "updateTimestamp",
    sortDir: "desc",
    featureFlag: "remarketing-quotes"
  },
  {
    label: "Expanded Markets",
    name: "expandedMarket",
    slug: "expanded-markets",
    filterType: "and",
    property: "carrierId",
    activeValue: "VAVE",
    sortField: "updateTimestamp",
    sortDir: "desc",
    featureFlag: "xm-vave"
  }
];

export const QuoteStatuses = {
  DRAFT: "Draft",
  NEED_REVIEW: "UW review needed",
  PENDING_REVIEW: "Pending UW Review",
  INELIGIBLE: "Ineligible",
  SUBMIT: "Ready to submit"
};

export const SCREEN_WIDTH = {
  FULL: "2520px",
  FOOTER_FULL: "2510px",
  NARROW: "1320px"
};

export const EMPTY_VALUE_PLACEHOLDER = "---";
export const DATEFORMAT = "MM-dd-yyyy";
export const XMLEAD = "xmlead";

export const POST_BIND_MODAL_TEXT = {
  modalTitle: "Application submitted successfully for",
  title: "How would you like to send the Enrollment Package Documents?",
  titleCaption:
    "Please take a moment to send the Enrollment Package Documents by choosing one of the options below:",
  optionTitleEsign: "Request e-signature",
  optionTitleEsign2: "(+ option to email PDF documents)",
  optionTextEsign:
    "Select this option to request e-signatures from the primary recipient for all documents requiring a signature. You will be notified via email once these signatures have been completed.",
  optionTextEsign2:
    "You will have the option to email PDF documents to other interested parties once you have selected your primary e-signature recipient.",
  optionTitleEmail: "Email PDF documents",
  optionTextEmail:
    "Select this option to email a PDF of Enrollment Package Documents to all recipients entered in 'Cc.' Separate multiple addresses with a comma (example: j.smith@mail.com, jane.smith@mail.com).",
  optionTitleSkip: "Do not send documents",
  optionTextSkip:
    "Select this option if you do not want to email documents to the insured or yourself.",

  insuredText: "Primary e-signature recipient:",
  insuredPlaceholder: "Insured email --required--",
  insuredValidationMsg: "Please provide a valid email address",
  insuredEmailText: "Insured:",
  insuredEmailPlaceholder: "Insured email --required--",
  insuredEmailValidationMsg: "Please provide a valid email address",
  producerText: "Producer email:",
  producerPlaceholder: "Producer email --required--",
  producerValidationMsg: "Please provide a valid email address",
  recipientsText: "PDF recipient(s):",
  recipientsPlaceholder: "PDF recipient email(s) --optional--",
  recipientsValidationMsg:
    "Please provide a comma separated list of valid email addresses",
  ccText: "Cc:",
  ccPlaceholder: "PDF recipient email(s) --optional--",
  ccValidationMsg:
    "Please provide a comma separated list of valid email addresses",
  subjectText: "Subject:",
  subjectValidationMsg: "Please provide a subject",
  messageText: "Message:",
  messageValidationMsg: "Please provide a message",
  policyDocumentsText: "Policy documents:",
  skipMessage:
    "You have selected to not send Enrollment Package Documents to the insured or yourself.",
  skipMessage2:
    'If you would like to send Enrollment Package Documents, please select "Email PDF documents" on the left.',
  noneTitle:
    "Select an option on the left to send Enrollment Package Documents",
  noneMessage: "The list below includes all documents for this policy",

  sendButtonText: "Send documents",
  skipButtonText: "Do not send documents",

  successMessage:
    "Thank you, your documents have been sent - SageSure Agent Portal",
  failedMessage: "Something went wrong, please try again",
  errorText1: "We're sorry! Something went wrong. Please try again.",
  errorText2:
    "If this problem persists more than 15 minutes, contact Technical Support at (877) 304-4785 option #2.",
  errorDetailsLabel: "View details",

  helpUrl: "",

  helpPrimaryAnchor:
    "The email address of the primary signatory is required in order to request the electronic signature.",
  helpEmailPrimaryAnchor:
    "An email address for the Insured is required for PDF documents.",
  helpProducerAnchor:
    "The producer email address is pre-populated with system data and is required as that is the means of notification on requested signature status.",
  helpPDFAnchor:
    "All email addresses entered in this space will be sent an email containing a PDF of signed Enrollment Package Documents. These PDFs will be sent once all signatures and reviews have completed.  The producer email address is pre-populated with system data and can be edited or removed. To enter multiple email recipients, separate email addresses with a comma: j.smith@mail.com, jane.smith@mail.com",
  helpPDFccAnchor:
    "All email addresses entered in this space will be sent an email containing a PDF of unsigned Enrollment Package Documents. The producer email address is pre-populated with system data and can be edited or removed. To enter multiple email recipients, separate email addresses with a comma: j.smith@mail.com, jane.smith@mail.com",
  helpSubjectAnchor:
    "You are able to customize the Subject of this email by editing this text.",
  helpMessageAnchor:
    "You are able to customize the Message of this email by editing this text."
};

// Expanded Market Carrier Names
export const VAVE_CARRIER_NAME = "VAVE";
export const XMCARRIERNAMES = [VAVE_CARRIER_NAME];

// Special Carrier IDS
export const TRIUM_CARRIER_IDS = ["TAIIC", "TWIC", "TACIC"];

export const QUOTE_DISCOVERY_HEADERS = [
  {
    label: "Customer",
    id: "insuredLastName",
    cssSuffix: "customer"
  },
  {
    label: "Quote",
    id: "id",
    cssSuffix: "quote"
  },
  {
    label: "Product",
    id: "product",
    cssSuffix: "product"
  },
  {
    label: "Effective Date",
    id: "effectiveDate",
    cssSuffix: "date"
  },
  {
    label: "Status",
    id: "updateTimestamp",
    cssSuffix: "status"
  },
  {
    label: null,
    id: "links",
    cssSuffix: "links"
  }
];
